import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IonicPage, NavController, NavParams} from 'ionic-angular';

import { ConsumerRewardDetailPage } from '../../pages/consumer-reward-detail/consumer-reward-detail';

import { Globals } from '../../providers/globals';
import { ConsumerRewardHandlerProvider } from '../../providers/consumer-reward-handler';

/**
 * Generated class for the ConsumerRewardCardComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'consumer-reward-card',
  templateUrl: 'consumer-reward-card.html'
})
export class ConsumerRewardCardComponent {
	@Input('reward') reward;

	filePath: any;
	isPinned: any = false;

	constructor(
		public navCtrl: NavController,
		public consumerRewardHandlerProvider: ConsumerRewardHandlerProvider,
		public globals: Globals,
		) {
		this.filePath = this.globals.fileUrl;
	}

	ngOnInit() {
		if(this.reward.IsPinned){
			this.isPinned = true;
		}    
	}  

	pin(){  
		if(this.isPinned){
		  this.isPinned = false;  
		}else{
		  this.isPinned = true;  
		}       

		this.reward.IsPinned = this.isPinned

		var params = {
		  rewardId: this.reward.Id,
		  pinned: this.isPinned
		}

		//this.consumerRewardHandlerProvider.pin(params, null)
	}

	gotoRewardDetail(event, reward){
	    this.navCtrl.push(ConsumerRewardDetailPage, {
	      reward: reward,
	      caller: this,
	    });
	}
}



// WEBPACK FOOTER //
// ./src/components/consumer-reward-card/consumer-reward-card.ts